// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';
import { VISIT_STORE_ANCHOR_WIDTH } from 'shared/layouts/DetailsPage/components/ProductInfo/constants';

export const Container = styled.div`
  position: relative;
  margin: ${({ theme }) => `${theme.spacing.spacing20} 0 ${theme.spacing.spacing40} 0`};
  display:flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.spacing80};
`;

export const AnchorVisitStore = styled.a`
  flex: none;
  ${({ theme }) => theme.typography.buttonMedium};
  color: ${({ theme }) => theme.colors.secondary};
  text-transform: capitalize;
  margin: 0;
  display: none;

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    display: block;
    text-decoration: none;
    margin-bottom: 0;
    right: ${({ theme }) => theme.spacing.spacing0};
    top: 0;
    position: absolute;
  }
`;

export const SubTitle = styled.span`
  margin: 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyLarge};

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyMedium};
  }
`;

export const AnchorTitle = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleMedium};
  width: fit-content;
  line-height: ${({ theme }) => theme.spacing.spacing120};

  &:hover {
    text-decoration: none;
  }

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    ${({ theme }) => theme.typography.buttonLarge};
    max-width: calc(100% - ${VISIT_STORE_ANCHOR_WIDTH}px);
  }
`;

export const TextTitle = styled.div`
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    ${({ theme }) => theme.typography.buttonMedium};
  }
`;

export const TitleWrapper = styled.h1`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 0;
`;

export const ProductTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.spacing10};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  `;

export const IconWrapper = styled.a`
  display: flex;
  justify-content: center;
  width: ${({ theme }) => theme.spacing.spacing100};
  `;

export const ActionContainer = styled.div`
  display: none;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    display: block;
    height: ${({ theme }) => theme.spacing.spacing200};
    width: ${({ theme }) => theme.spacing.spacing200};
    border-radius: ${({ theme }) => theme.borders.radiusFull};
    border: 1px solid ${({ theme }) => theme.colors.textOutline};
    padding: ${({ theme }) => theme.spacing.spacing10};
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;